import React, { useState } from 'react';

import {
  mdiAccountOutline,
  mdiPlusBoxOutline,
  mdiSquareEditOutline,
} from '@mdi/js';
import EstablishmentBox from '~/shared/components/establishmentBox';
import ProfileBox from '~/shared/components/profileBox';
import EstablishmentEditionModal from '~/shared/components/establishmentEditionModal';
import EstablishmentCreatedModal from '~/shared/components/establishmentCreatedModal';
import { ModalPharmacist } from '~/shared/components';
import ProfileEditionModal from '~/shared/components/profileEditionModal';

import {
  Container,
  ButtonCreateEstablishment,
  ButtonContainer,
} from './styles';

const Profile = () => {
  const [perfilEditionModal, setPerfilEditionModal] = useState(false);
  const [establishmentEditionModal, setEstablishmentEditionModal] =
    useState(false);
  const [establishmentCreatedModal, setEstablishmentCreatedModal] =
    useState(false);

  const toggleModal = () => setPerfilEditionModal((state) => !state);
  const establishmentToggleModal = () =>
    setEstablishmentEditionModal((state) => !state);
  const establishmentCreatedToggleModal = () =>
    setEstablishmentCreatedModal((state) => !state);

  return (
    <Container>
      <ProfileBox
        title="Meu perfil"
        iconSubTitle={mdiAccountOutline}
        icon={mdiSquareEditOutline}
        colorSubTitle="#454F63"
        color="#2493EB"
        setModalOpen={() => setPerfilEditionModal(true)}
        subTitle="Meus dados"
      />
      <EstablishmentBox
        title="Estabelecimentos cadastrados"
        subTitle="Drogaria Avenida"
        iconSubTitle={mdiPlusBoxOutline}
        icon={mdiSquareEditOutline}
        colorSubTitle="#454F63"
        color="#2493EB"
        setModalOpen={() => setEstablishmentEditionModal(true)}
      />
      <ButtonContainer>
        <ButtonCreateEstablishment
          onClick={() => setEstablishmentCreatedModal(true)}
        >
          Cadastrar estabelecimento
        </ButtonCreateEstablishment>
      </ButtonContainer>
      <ModalPharmacist
        isOpen={perfilEditionModal}
        title="Edição de perfil"
        widthContainer="60%"
        onCloseRequest={toggleModal}
      >
        <ProfileEditionModal onClose={toggleModal} />
      </ModalPharmacist>
      <ModalPharmacist
        isOpen={establishmentEditionModal}
        title="Edição de estabelecimento"
        widthContainer="60%"
        onCloseRequest={establishmentToggleModal}
      >
        <EstablishmentEditionModal onClose={establishmentToggleModal} />
      </ModalPharmacist>
      <ModalPharmacist
        isOpen={establishmentCreatedModal}
        title="Criação de estabelecimento"
        widthContainer="60%"
        onCloseRequest={establishmentCreatedToggleModal}
      >
        <EstablishmentCreatedModal onClose={establishmentCreatedToggleModal} />
      </ModalPharmacist>
    </Container>
  );
};

export default Profile;
